import { call, type ForkEffect, put, takeLatest } from 'redux-saga/effects';
import type { AxiosResponse } from 'axios';

import * as auditApiService from '../../services/auditApiService';

import type { IAuditResponse, IDocumentHistoryResponse } from './types';
import * as slicesActions from './slices';
import * as actions from './actions';

function* getDocumentHistory({ payload }: ReturnType<typeof actions.getDocumentHistory>) {
  try {
    yield put(slicesActions.setDocumentHistoryLoading(true));
    const { data }: AxiosResponse<IDocumentHistoryResponse> = yield call(auditApiService.getDocumentHistory, payload);

    yield put(slicesActions.setDocumentHistory(data));
  } catch (err) {
    console.error(err);
  } finally {
    yield put(slicesActions.setDocumentHistoryLoading(false));
  }
}

function* getVersionComparison({ payload }: ReturnType<typeof actions.getVersionComparison>) {
  try {
    yield put(slicesActions.setVersionComparisonLoading(true));
    const { data }: AxiosResponse<IAuditResponse> = yield call(auditApiService.getVersionComparison, payload);

    yield put(slicesActions.setVersionComparison(data));
  } catch (err) {
    console.error(err);
    yield put(slicesActions.resetVersionComparison());
  } finally {
    yield put(slicesActions.setVersionComparisonLoading(false));
  }
}

export function* watchAuditSaga(): Generator<ForkEffect> {
  yield takeLatest(actions.getDocumentHistory.type, getDocumentHistory);
  yield takeLatest(actions.getVersionComparison.type, getVersionComparison);
}
